<style>
  .modal-header{
    text-transform: capitalize;
  }
  .modal-body {
    padding: 0 1rem;
  }
</style>

<style scoped>
  .form-control{
    border: none;
    background: #eee;
    font-size: 1.2em;
    color: #000;
  }

  textarea{
    resize: none;
  }
</style>

<template>
  <form @submit="saveSupportedBank">
    <b-modal title="Edit Bank Details" :visible="bankId !== null"
      @ok="close" @cancel="close" @hide="close">

      <Loader v-if="!supportedBankBeingEdited" :size="40" />

      <template v-else>
        <div class="row">
          <div class="form-group mt-3 mb-4 col-md-7">
            <label for="value" class="text-capitalize">Name</label>
            <input id="value" class="form-control" type="text" required
              @input="setBankName($event)"
              :value="name"
            />
          </div>
          
          <div class="form-group mt-3 mb-4 col-md-5">
            <label for="value" class="text-capitalize">Short Name</label>
            <input id="value" class="form-control" v-model="code" type="text" required />
          </div>
        </div>

        <template slot="modal-footer">
          <div class="row justify-content-end pb-0">
            <div class="px-3">
              <button :class="{disabled: savingSupportedBank}" class="btn btn-primary px-4">
                {{ !savingSupportedBank ? 'SUBMIT' : 'Please Wait...' }}
              </button>
            </div>
          </div>
        </template>
      </template>
    </b-modal>
  </form>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'EditSupportedBank',
    props: {
      bankId: {
        type: String,
        required: true
      }
    },
    mounted(){
      if(!this.supportedBanks && !this.fetchingSupportedBanks){
        this.$store.dispatch('getSupportedBanks');
        this.$store.subscribe(mutation => {
          if(mutation.type === 'SET_SUPPORTED_BANKS')
            this.$store.dispatch('setSupportedBankBeingEdited', this.bankId);
        });
      }
      else
        this.$store.dispatch('setSupportedBankBeingEdited', this.bankId);
    },
    beforeDestroy(){
      this.$store.dispatch('setSupportedBankBeingEdited', null);
    },
    data(){
      return {
        name: '',
        code: ''
      }
    },
    computed: {
      ...mapState(['supportedBanks', 'fetchingSupportedBanks', 'supportedBankBeingEdited', 'savingSupportedBank'])
    },
    watch: {
      supportedBankBeingEdited: function(supportedBank){
        if(!supportedBank)
          return;

        this.name = supportedBank.name;
        this.code = supportedBank.code;
      }
    },
    methods: {
      close(){
        this.$router.replace('/configurations/supportedBanks');
      },
      setBankName(event){
        const newValue = event.target.value;
        this.name = newValue;
        this.code = newValue.split(" ").map(word => word[0]).join("").toUpperCase();
      },
      saveSupportedBank(e){
        e.preventDefault();
        if(!this.supportedBankBeingEdited)
          return;

        const data = {
          _id: this.supportedBankBeingEdited._id,
          name: this.name,
          code: this.code
        };

        this.$store.dispatch('updateSupportedBank', data);
      }
    }
  }
</script>
